import { render, staticRenderFns } from "./HomeCultures.vue?vue&type=template&id=5120b4de"
import script from "./HomeCultures.vue?vue&type=script&lang=js"
export * from "./HomeCultures.vue?vue&type=script&lang=js"
import style0 from "./HomeCultures.vue?vue&type=style&index=0&id=5120b4de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports